import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import Assets from '../../requests/apa/Asset';
import './styles/modal-register-net.scss';

const ModalRegisterNet = (props = {}) => {
  const buttons = [
    {
      extraClass: 'btn_modal_register_claro',
      props: {
        onClick: (e) => props.handleClose(e, props.callback('claro')),
        imgSrc: Assets.get('login_register_net_icon_logoClarovideo', ''),
        isRegisterNet: true,
      },
      selected:true,
    },
    {
      extraClass: 'btn_modal_register_claro_net',
      props: {
        onClick: (e) => props.handleClose(e, props.callback('net')),
        imgSrc: Assets.get('login_register_net_icon_logoNET', ''),
      },
    },
    {
      extraClass: 'btn_modal_register_claro',
      props: {
        onClick: (e) => props.handleClose(e, props.callback('hdtv')),
        imgSrc: Assets.get('login_register_net_icon_logoHDTV', ''),
      },
    },
    {
      content: Translator.get('login_register_net_option_button_cancel', 'CANCELAR'),
      extraClass: 'btn-modal-register-net-cancel',
      props: {
        onClick: (e) => props.handleClose(e, props.onClose),
        variant: 'dark'
      }
    }
  ];
  const customizedClassName =`modal-button-return`;
  const p = {
      showNetTitle: true,
      netTitle:  Translator.get('login_net_title_label', 'Faça login com a sua operadora'),
      buttonsAlign: 'horizontal',
      buttons: buttons,
      extraClass: 'btn-modal-register-spatial',
      showFooterRegisterNet: true,
      footerText:  Translator.get('login_register_net_description_label', 'Debes seleccionar un servicio de NET'),
      colorButtons: [{
        content: Translator.get('top_head_option_button_back', 'REGRESAR'),
        props: {
          color: 'yellow',
          className: customizedClassName,
          imgSrc: Assets.get('top_head_option_back', ''),
          onClick: (e) => props.handleClose(e, props.onClose)
        }
        }],
      aafNewStyle: true,
      showLogo: false,
  };

  return <ModalWrapper {...p} />;
};

export default withOnClose(ModalRegisterNet);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalRegisterNet.jsx